import React from 'react';
import { departments } from '../../../data/mockJobs';
import { JobFilters } from './types';
import { useLanguage } from '../../../contexts/LanguageContext';

interface JobFiltersProps {
  filters: JobFilters;
  onFilterChange: (filters: JobFilters) => void;
}

export const JobFiltersComponent = ({ filters, onFilterChange }: JobFiltersProps) => {
  const { t } = useLanguage();
  
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const years = Array.from(
    { length: 5 },
    (_, i) => new Date().getFullYear() - i
  );

  return (
    <div className="bg-white rounded-lg border p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('dashboard.completedJobs.filters.month')}
          </label>
          <select
            value={filters.month}
            onChange={(e) => onFilterChange({ ...filters, month: Number(e.target.value) })}
            className="w-full px-3 py-2 bg-white border rounded-lg focus:ring-2 focus:ring-blue-500 transition-shadow"
          >
            {months.map((month, index) => (
              <option key={month} value={index}>
                {month}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('dashboard.completedJobs.filters.year')}
          </label>
          <select
            value={filters.year}
            onChange={(e) => onFilterChange({ ...filters, year: Number(e.target.value) })}
            className="w-full px-3 py-2 bg-white border rounded-lg focus:ring-2 focus:ring-blue-500 transition-shadow"
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('dashboard.completedJobs.filters.department')}
          </label>
          <select
            value={filters.department}
            onChange={(e) => onFilterChange({ ...filters, department: e.target.value })}
            className="w-full px-3 py-2 bg-white border rounded-lg focus:ring-2 focus:ring-blue-500 transition-shadow"
          >
            <option value="">{t('dashboard.completedJobs.filters.allDepartments')}</option>
            {departments.map((dept) => (
              <option key={dept} value={dept}>
                {dept}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};